jQuery($ => {
	function tabindexFixer() {
		const $items = this.$element.find('.owl-item');
		$items.each(function () {
			if ($(this).hasClass('active')) {
				$(this).find('a').removeAttr('tabindex');
			} else {
				$(this).find('a').attr('tabindex', '-1');
			}
		});
	}

	function dotUpdate(e) {
		const $firstNotCloned = this.$element.find('.owl-item').not('.cloned').first();
		const cloneCount = $firstNotCloned.prevAll().length;
		const idx = e.item.index - cloneCount;
		this.$element.next('.controls').find('.slide-pagination > a').eq(idx).addClass('active').siblings().removeClass('active');
	}

	function parentStyleDataUpdate() {
		if (!this.$element) {
			return;
		}
		const $activeElement = this.$element.find('.owl-item.active');
		if ($activeElement.length === 0) {
			return;
		}
		const style = $activeElement.find('.slide').attr('data-style');
		this.$element.attr('data-current-style', style);
		if (style === '2') {
			this.$element.next('.controls').css('paddingBottom', '');
			return;
		}
		let xPos = [...this.$element.find('.owl-item.active').find('.slide').get(0).classList].filter(c => c.startsWith('box-x-'));
		xPos = xPos[0] ? xPos[0].replace('box-x-', '') : 'left';
		this.$element.attr('data-current-box-x', xPos);
		let yPos = [...this.$element.find('.owl-item.active').find('.slide').get(0).classList].filter(c => c.startsWith('box-y-'));
		yPos = yPos[0] ? yPos[0].replace('box-y-', '') : 'bottom'
		// this.$element.attr('data-current-box-y', yPos);
		// if (yPos !== 'bottom') {
		const $slide = this.$element.find('.owl-item.active').find('.slide');
		const sliderHeight = this.$element.outerHeight();
		const textBoxHeight = $slide.find('.text-box').outerHeight();
		const textBoxPaddingBottom = window.innerWidth >= 768 ? parseInt($slide.find('.text-box').css('paddingBottom'), 10) : 32;
		let textBoxBottom;
		if (yPos === 'bottom') {
			textBoxBottom = 0;
		} else if (yPos === 'center') {
			textBoxBottom = (sliderHeight - textBoxHeight) / 2;
		} else {
			textBoxBottom = sliderHeight - textBoxHeight;
		}
		this.$element.next('.controls').css('paddingBottom', (textBoxBottom + textBoxPaddingBottom) + 'px');
		// }
	}

	const $carousels = $('section.carousel .owl-carousel');
	$carousels.each(function () {
		if ($(this).children('.slide').length === 1) {
			$(this).show().next('.controls').hide();
			return;
		}
		const animation = $(this).attr('data-animation') || '';
		$(this).owlCarousel({
			items: 1,
			nav: false,
			loop: true,
			dots: false,
			animateOut: animation,
			onInitialized: function () {
				tabindexFixer.apply(this);
				parentStyleDataUpdate.apply(this);
			},
			onTranslated: function (e) {
				tabindexFixer.apply(this);
				dotUpdate.apply(this, [e]);
				parentStyleDataUpdate.apply(this);
			},
			onDrag: function () {
				this.$element.next('.controls').addClass('drag');
			},
			onDragged: function () {
				this.$element.next('.controls').removeClass('drag');
			},
		});
	});

	if ($carousels.length) {
		$('section.carousel .slide-pagination a').click(function (e) {
			e.preventDefault();
			const idx = $(this).index();
			const $carousel = $(this).closest('section').children('.owl-carousel');
			$carousel.trigger('to.owl.carousel', [idx]);
		});

		$('section.carousel .slide-controls a').click(function (e) {
			e.preventDefault();
			const $carousel = $(this).closest('section').children('.owl-carousel');
			if ($(this).hasClass('prev')) {
				$carousel.trigger('prev.owl.carousel');
			} else {
				$carousel.trigger('next.owl.carousel');
			}
		});

		$(window).on('resize', () => {
			$carousels.each(function () {
				parentStyleDataUpdate.apply($(this).data('owl.carousel'));
			});
		});
	}
});
